import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DataJson } from '@app/services/assets/assets.service';

@Injectable({
  providedIn: 'root',
})
export class CommonDataService {
  private data$ = new BehaviorSubject<DataJson>({} as DataJson);

  public getData(): Observable<DataJson> {
    return this.data$.asObservable();
  }

  public setData(data: DataJson): void {
    this.data$.next(data);
  }
}
